/**
 * Paso5.js
 */

//Dependencies
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import $ from 'jquery';
import Camara from './NuevaCamara';
import { Layout } from './layout/Layout';
import { IndicacionCamara } from './customModals/IndicacionCamara';
import { onBoardingDigital } from '../../actions/actions';
import { setErrorMessage } from '../../actions/actions';


//material-ui
import Grid from '@material-ui/core/Grid';

//Assets
import face from '../../static/img/face.png';

//Services
import { storeUrlRiesgoNet } from './services/riesgoNetService';
import { processToken } from './services/tokenService';
import { processIdClientAnalytics } from './services/pixelService';
import { processFlow } from './services/flowService';

class Paso5 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paso: 5,
            disabled: false,
        }

        this.paso5 = this.paso5.bind(this);
        this.camaraRef = createRef();
        this.validateFlow = this.validateFlow.bind(this);
        this.validateToken = this.validateToken.bind(this);
        this.setSiguientePaso = this.setSiguientePaso.bind(this);
        this.validateImageOperationVU = this.validateImageOperationVU.bind(this);
    }

    componentWillMount() {
        this.validateFlow();
        this.validateToken();
        processIdClientAnalytics('paso-5')
    }

    componentDidUpdate() {
        $(".load").fadeOut(700);
    }

    validateFlow() {
        processFlow(this.props.history, this.state.paso);
    }

    validateToken() {
        processToken(this.props.history);
    }

    validateImageOperationVU(image) {
        const validateImageOperation = {
            imageType: 'SN',
        };

        let formData = new FormData();
        formData.append("file", image);
        formData.append('data', new Blob([JSON.stringify(validateImageOperation)], {
            type: "application/json"
        }));

        $(".load").fadeIn(700);
        axios({
            method: 'post',
            timeout: 60 * 4 * 1000,
            data: formData,
            url:  localStorage.getItem('url') + '/api/vu/validateImageOperation'
        }).then(() => {
            $(".load").fadeOut(700);
            this.setSiguientePaso();
            return this.props.history.push('/paso-7')
        }).catch(error => {
            if (error.response.status == 500 && sessionStorage.getItem('tipoFlujo') != 'standalone') {
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/error-servicio')
                });
            }else  if (error.response.status == 500 && sessionStorage.getItem('tipoFlujo') == 'standalone') {
                storeUrlRiesgoNet(this.props.history).then(() => {
                    this.props.history.push('/error-standalone')
                });
            } else {
                this.props.dispatch(
                    setErrorMessage(error.response.data.message)
                );
                if (error.response.data.message == null) {
                    if(sessionStorage.getItem('tipoFlujo') != 'standalone')
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-servicio')
                    });
                    else if(sessionStorage.getItem('tipoFlujo') == 'standalone')
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-standalone')
                    });
                } else {
                    storeUrlRiesgoNet(this.props.history).then(() => {
                        this.props.history.push('/error-prueba-vida')
                    });
                }
            }
        })
    }

    paso5() {
        this.setState({disabled : true})
        //Exito, continuar al paso 6 (que no exite)
        processIdClientAnalytics('paso-6')
        //Manejo imperativo del hijo
        //Necesitamos que este scope de ejecución del onClick() se propague para poder abrir la camara.
        this.camaraRef.current.handleClick();
    }

    setSiguientePaso() {
        this.props.dispatch(
            onBoardingDigital(this.state.paso + 1)
        );
    }

    render() {
        const header = {
            progress : {value : 75}
        };
        const footer = {
            button: {
                action : this.paso5,
                text : "Sacar Foto",
                disabled : this.state.disabled
            }
        };
        const mensaje = <React.Fragment>Para tomar la foto, asegurate de que la cámara quede en formato <b>vertical</b> y ubicá tu rostro en el centro de la pantalla</React.Fragment>;
        const body = {
            img : {
                src : face
            },
            slot : <IndicacionCamara vertical mensajePantalla={mensaje}/>
        }
        return (
            <Layout header={header} footer={footer} body={body}
                tieneFooter>
                <Grid container item xs={12} sm={12} justify="center">
                    <div className="content-description">
                        <h5 className="title" >Tomá una foto de tu rostro</h5>
                        <h6 className="description">Asegurate de que haya suficiente luz.</h6>
                    </div>
                </Grid>
                <Camara ref={this.camaraRef} parentHandleImage={this.validateImageOperationVU} capture='user'/>
            </Layout>
        );
    }
}

export default connect()(Paso5);


// WEBPACK FOOTER //
// ./src/components/OnBoarding/Paso5.js